import { initSentry } from '@pflegenavi/shared-frontend/platform';

export {
  setSentryAuthContext,
  setSentryApiUrl,
} from '@pflegenavi/shared-frontend/platform';

export const { SentryRoutes } = initSentry({
  dsn: 'https://c940ecb03b4649e688f605b8b4068178@o1342624.ingest.sentry.io/4505520834084864',
  appName: 'service-provider-web',
  enabled: import.meta.env.PROD,
});
